import "core-js/modules/es.array.reverse.js";
var _class, _BooleanParameter;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import FunctionParameter from "./FunctionParameter";
let BooleanParameter = (_class = (_BooleanParameter = class BooleanParameter extends FunctionParameter {
  /**
   * Gets a value indicating whether this parameter has names for its "true" and "false" states.
   */
  get hasNamedStates() {
    return typeof this.trueName === "string" && typeof this.falseName === "string";
  }
  constructor(catalogFunction, options) {
    super(catalogFunction, options);
    _defineProperty(this, "type", "boolean");
    _defineProperty(this, "trueName", void 0);
    _defineProperty(this, "trueDescription", void 0);
    _defineProperty(this, "falseName", void 0);
    _defineProperty(this, "falseDescription", void 0);
    makeObservable(this);
    this.trueName = options.trueName;
    this.trueDescription = options.trueDescription;
    this.falseName = options.falseName;
    this.falseDescription = options.falseDescription;
  }
}, _defineProperty(_BooleanParameter, "type", "boolean"), _BooleanParameter), _applyDecoratedDescriptor(_class.prototype, "hasNamedStates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNamedStates"), _class.prototype), _class);
export { BooleanParameter as default };